import React from "react";
import constants from "../../constants/system.js";
import { useUser } from "../../context/userContext";

export default function SystemOff() {
  const { language } = useUser();
  return (
    <div className="container">
      <h1>{constants.system.notAvaiable[language]}</h1>
    </div>
  );
}
